<template>
  <div class="cycle-details__wrapper">
    <ViewHeader
      :title="$route.params.entity_id + ' - ' + cycleName"
      compact
    />

    <CRow class="w-100 mb-2 ml-0 mr-0">
      <CCol col="10">
        <MzTabs
          v-model="currentTab"
          :tabs="tabs"
        />
      </CCol>
      <CCol col="2" class="pr-0">
        <div class="w-100 d-flex justify-content-end">
        <CButton
          class="mz-button v2-mz-btn btn-primary mt-2 ml-auto"
          :to="{ name: 'Create task', params: { id: 'create' }, query: { ticket_data: getQueryParams() } }"
        >
          Create Ticket
        </CButton>
      </div>
      </CCol>
    </CRow>

    <TestResultWrapper
      :key="currentTab"
      :testName="testNames[currentTab]"
      :testId="currentTab"
    >
    </TestResultWrapper>
  </div>
</template>

<script>
import { CYCLES } from "@/constants/cycle";
import { ClosingFileService } from "@/services/closing_file";
import TestResultWrapper from "@/components/closingFile/TestResultWrapper";
import { encode } from "querystring"

export default {
  name: "CycleDetails",
  components: {TestResultWrapper},
  data() {
    return {
      cycle: this.$route.params.cycle,
      cycleName: "",
      currentTab: "",
      tabs: [],
      testNames: {},
    };
  },
  mounted() {
    this.cycleName = CYCLES[this.cycle];
    this.$store.commit("set", ["cycleName", this.cycleName]);
    this.getNavTabs();
  },
  methods: {
    async getNavTabs(){
      const availableTests = await ClosingFileService.getAvailableTests();
      this.testNames = availableTests[this.cycleName];
      this.tabs = Object.keys(this.testNames);
      const urlTab = this.$route.query?.tab;
      this.currentTab = this.tabs.includes(urlTab) ? urlTab : this.tabs[0];
    },
    getFormattedCycleName() {
      return `[${this.$route.params.quarter_name} - ${this.currentTab}] ${this.cycleName}`
    },
    getFormattedQuarterName() {
      const quarterName = this.$route.params.quarter_name;
      return `${quarterName.slice(0, 4)} - ${quarterName.slice(4)}`;
    },
    getQueryParams() {
      const query = {
        title: this.getFormattedCycleName(),
        entity_code: this.$route.params.entity_id,
        services: "Service comptable",
        contexte: "Clôture trimestrielle",
        label: "Clôture",
        assignee: "",
        description: `<p><a href="${window.location.href}">${this.getFormattedQuarterName()}</a></p>`,
        test_code: this.currentTab,
        quarter_name: this.$route.params.quarter_name
      }
      return btoa(encode(query))
    },
  },
};
</script>
